import { create } from 'zustand';
import {
    GetRadioBaseParams,
    getRadioBases
} from '@/shared/actions/erp'
import { RadioBase } from '@/shared/interfaces/erp/mantenimiento-operaciones';

interface RadioBaseStore {
    radioBases: RadioBase[];
    isLoadingRadioBases: boolean;
    getRadioBases: (params?: GetRadioBaseParams) => Promise<void>;
}
export const useRadioBaseStore = create<RadioBaseStore>((set) => ({
    radioBases: [],
    isLoadingRadioBases: false,
    getRadioBases: async (params) => {
            set((state) => ({ ...state, isLoadingRadioBases: true }));
            await getRadioBases(params);
            set((state) => ({ ...state, isLoadingRadioBases: false }));   
    }
}));